import MenuContext from './MenuContext'
import React from 'react'

type Menu = JSX.Element | undefined

const MenuProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMenu, showMenu] = React.useState<number | boolean>(false)
  const menuRef = React.useRef<Menu>(undefined)

  const updateMenu = React.useCallback((menu: Menu = undefined) => {
    menuRef.current = menu
    showMenu(menu ? Date.now() : false)
  }, [])

  React.useEffect(() => {
    if (isMenu) {
      const handleClick = (_: Event) => updateMenu()
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.code === 'Escape') updateMenu()
      }

      window.addEventListener('click', handleClick)
      window.addEventListener('keydown', handleKeyDown)

      return () => {
        window.removeEventListener('click', handleClick)
        window.removeEventListener('keydown', handleKeyDown)
      }
    }
  }, [isMenu, updateMenu])

  return (
    <MenuContext.Provider value={updateMenu}>
      {isMenu ? menuRef.current : false}
      {children}
    </MenuContext.Provider>
  )
}

export default MenuProvider
